// extracted by mini-css-extract-plugin
export default {"container":"TrustedCompanies_container__r0Ndp","text":"TrustedCompanies_text__0nC1F","logos":"TrustedCompanies_logos__sCoyD"};